import 'bootstrap/dist/css/bootstrap.min.css';
import "bootstrap-icons/font/bootstrap-icons.css";
import { Route, Routes } from 'react-router-dom';
import GalleryPage from './pages/GalleryPage';
import NotFound from './pages/NotFound';
import './styles/mystyle.css'


function App() {
  return (
  
    <Routes>
      <Route path="/*" element={<GalleryPage />} />
      <Route path="/404" element={<NotFound />} />
    </Routes>
  );
}

export default App;
